import React from 'react';
import Icon from 'components/AppIcon';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, action, adminName, language }) => {
  if (!isOpen) return null;

  const translations = {
    en: {
      confirmDeactivate: "Confirm Deactivation",
      confirmDelete: "Confirm Deletion",
      deactivateMessage: "Are you sure you want to deactivate this admin account?",
      deleteMessage: "Are you sure you want to delete this admin account? This action cannot be undone.",
      adminAccount: "Admin Account",
      thisWillPrevent: "This will prevent the user from accessing the system.",
      allDataWillBeLost: "All data associated with this account will be permanently removed.",
      cancel: "Cancel",
      deactivate: "Deactivate",
      delete: "Delete"
    },
    ar: {
      confirmDeactivate: "تأكيد إلغاء التفعيل",
      confirmDelete: "تأكيد الحذف",
      deactivateMessage: "هل أنت متأكد من أنك تريد إلغاء تفعيل حساب المشرف هذا؟",
      deleteMessage: "هل أنت متأكد من أنك تريد حذف حساب المشرف هذا؟ لا يمكن التراجع عن هذا الإجراء.",
      adminAccount: "حساب المشرف",
      thisWillPrevent: "سيمنع هذا المستخدم من الوصول إلى النظام.",
      allDataWillBeLost: "ستتم إزالة جميع البيانات المرتبطة بهذا الحساب نهائياً.",
      cancel: "إلغاء",
      deactivate: "إلغاء التفعيل",
      delete: "حذف"
    }
  };

  const t = translations[language];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center mb-4">
            <div className={`p-2 rounded-full ${action === 'delete' ? 'bg-red-100' : 'bg-yellow-100'}`}>
              <Icon 
                name={action === 'delete' ? 'Trash2' : 'AlertTriangle'} 
                size={24} 
                className={action === 'delete' ? 'text-red-600' : 'text-yellow-600'} 
              />
            </div>
            <h3 className="ml-3 text-lg font-semibold text-gray-900">
              {action === 'delete' ? t.confirmDelete : t.confirmDeactivate}
            </h3>
          </div>

          {/* Content */}
          <div className="mb-6">
            <p className="text-gray-700 mb-3">
              {action === 'delete' ? t.deleteMessage : t.deactivateMessage}
            </p>
            
            <div className="bg-gray-50 p-3 rounded-lg">
              <p className="text-sm text-gray-600 mb-1">{t.adminAccount}:</p>
              <p className="font-medium text-gray-900">{adminName}</p>
            </div>
            
            <p className="text-sm text-gray-600 mt-3">
              {action === 'delete' ? t.allDataWillBeLost : t.thisWillPrevent}
            </p>
          </div>

          {/* Actions */}
          <div className="flex space-x-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              {t.cancel}
            </button>
            <button
              onClick={onConfirm}
              className={`flex-1 px-4 py-2 text-white rounded-lg transition-colors font-medium ${
                action === 'delete' 
                  ? 'bg-red-600 hover:bg-red-700' :'bg-yellow-600 hover:bg-yellow-700'
              }`}
            >
              {action === 'delete' ? t.delete : t.deactivate}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;